import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../App";
import { fetchDataFromApi } from "../../utils/api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ProductItem from "../../Components/ProductItem";
import NoProductsFound from "../../Components/NoProductsFound";

const FeaturedProducts = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const context = useContext(MyContext);

  useEffect(() => {
    fetchDataFromApi(`/api/products/featured`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setFeaturedProducts(res.data);
          setHasError(false);
        } else {
          setFeaturedProducts([]);
          setHasError(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching featured products:", error);
        setFeaturedProducts([]);
        setHasError(true);
        setIsLoading(false);
      });
  }, []);

  const SkeletonProductItem = () => (
    <div
      className="productItem bg-gray-200 rounded-lg overflow-hidden relative"
      style={{ width: "330px", height: "331px", margin: "0 10px" }}
    >
      <div className="w-full h-3/4 bg-gray-300 animate-pulse"></div>
      <div className="p-2.5 h-1/4">
        <div className="w-3/4 h-5 bg-gray-300 mb-2.5 animate-pulse"></div>
        <div className="w-1/2 h-5 bg-gray-300 animate-pulse"></div>
      </div>
      <div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-75 animate-shimmer"
        style={{
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
        }}
      ></div>
    </div>
  );

  const styles = `
  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  `;

  const styleTag = document.createElement("style");
  styleTag.innerHTML = styles;
  document.head.appendChild(styleTag);

  return (
    <>
      <div className="d-flex align-items-center mt-4">
        <div className="info">
          <h3 className="mb-0 hd">featured products</h3>
        </div>
      </div>

      {isLoading || hasError ? (
        <div className="product_row w-100 mt-2 flex">
          {[...Array(5)].map((_, index) => (
            <SkeletonProductItem key={index} />
          ))}
        </div>
      ) : featuredProducts?.length === 0 ? (
        <NoProductsFound />
      ) : (
        <div className="product_row">
          <div className="flex overflow-x-auto scrollbar-hide gap-[10px]">
            {featuredProducts.map((item, index) => (
              <div
                key={index}
                className="md:w-[250px] md:mx-2.5 md:h-[400px] bg-gray-200 rounded-lg w-full h-[390px] m-2.5 relative"
              >
                <ProductItem item={item} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FeaturedProducts;
